import { render, staticRenderFns } from "./Property.yaml?vue&type=template&id=a40d7818&component"
import script from "./Property.yaml?vue&type=script&lang=ts&component"
export * from "./Property.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports